import { useEffect, useState } from "react";
import { httpClient } from '../../HttpClient';

export default function ResumeSuiviSocial({
  selectedClient,
  client,
  idClient,
  mois,
  annee,
  onClose,
}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [notFound, setNotFound] = useState(false); // nouvel état pour 404
  const [openedEventId, setOpenedEventId] = useState(null);

  const formatDateTime = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    setLoading(true);
    setError(false);
    setNotFound(false);

    if (idClient && mois && annee) {
      httpClient
        .get(
          `https://backend-myalfa.vercel.app/api/suiviSocial/${idClient}/${mois}/${annee}`
        )
        .then((res) => {
          setData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response && err.response.status === 404) {
            // Cas 404
            setNotFound(true);
          } else {
            console.error("Erreur API:", err);
            setError(true);
          }
        });
    }
  }, [idClient, mois, annee]);

  const tables = [
    "AttestationAT",
    "DSNMaladieAT",
    "AttestationMaternitePaternite",
    "ChomagePartielle",
    "Dpae",
    "ContratDetravail",
    "Avenant",
    "CertiicatTravail",
    "AttestationPole",
    "RecuSolde",
    "RuptureConventionnelle",
    "Licenciement",
    "Demission",
    "FinPeriodedEssai",
    "FinContratPro",
    "FinContratApprenti",
    "RuptureCommun",
    "FinCdd",
    "CourriersDivers",
  ];

  const tableLabels = {
    AttestationAT: "Attestation papier AT",
    DSNMaladieAT: "DSN Maladie ou AT",
    AttestationMaternitePaternite: "Attestation maternité / paternité",
    ChomagePartielle: "Chômage partielle",
    Dpae: "DPAE",
    ContratDetravail: "Contrat de travail",
    Avenant: "Avenant",
    CertiicatTravail: "Certificat de travail",
    AttestationPole: "Attestation Pôle Emploi",
    RecuSolde: "Reçu pour solde de tout compte",
    RuptureConventionnelle: "Rupture conventionnelle",
    Licenciement: "Licenciement",
    Demission: "Démission",
    FinPeriodedEssai: "Fin période d'essai",
    FinContratPro: "Fin contrat de pro",
    FinContratApprenti: "Fin contrat d'apprenti",
    RuptureCommun: "Rupture commun",
    FinCdd: "Fin CDD",
    CourriersDivers: "Courriers divers",
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("fr-FR");
  };

  const renderField = (label, value) => (
    <p>
      <strong>{label} :</strong> {value || "-"}
    </p>
  );

  return (
    <div className="overlayAC">
      <div className="inoverlayMS">
        <button
          className="close-button"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "50px",
            right: "405px",
            background: "transparent",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            zIndex: 10000,
          }}
        >
          ✖
        </button>

        {loading && (
          <div
            className="CreateContainer"
            style={{ textAlign: "center", padding: "2rem" }}
          >
            <div className="spinner" />
          </div>
        )}

        {error && !loading && (
          <div
            style={{ textAlign: "center", marginTop: "100px", color: "red" }}
          >
            <h3>Erreur lors du chargement des données</h3>
          </div>
        )}

        {notFound && !loading && (
          <div
            style={{ textAlign: "center", marginTop: "100px", color: "gray" }}
          >
            <h3>Aucun détail n’a été ajouté dans le Suivi Social</h3>
          </div>
        )}

        {!loading && !error && !notFound && data && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              width: "80%",
            }}
          >
            <h2>
              Détails Social - {client} - {data.mois}/{data.annees}
            </h2>
            <hr style={{ margin: "25px 0", width: "100%" }} />
            <div
              className="divSection"
              style={{
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <span>
                <input type="checkbox" checked={data.preparationBS === "oui"} />{" "}
                Préparation BS
              </span>
              <span>
                {formatDateTime(data.preparationBSDate)}
                &nbsp; - &nbsp;
                {data.preparationBSUser}
              </span>
            </div>
            <div className="divSection" style={{ marginBottom: "20px" }}>
              <label>
                Nombre de BS : &nbsp; <strong>{data.nombreBS}</strong>
              </label>
            </div>
            <div
              className="divSection"
              style={{
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <span>
                <input type="checkbox" checked={data.dsn === "oui"} /> DSN
              </span>
              <span>
                {formatDateTime(data.dsnDate)}
                &nbsp; - &nbsp;
                {data.dsnUser}
              </span>
            </div>

            <br />
            <label>Remarques :</label>
            <div
              className="divSection"
              style={{
                marginBottom: "20px",
                alignItems: "start",
                marginTop: "10px",
              }}
            >
              <textarea
                style={{ width: "100%" }}
                value={data.commentaire}
                rows={5}
              />
            </div>
            <hr style={{ margin: "5px 0", width: "100%" }} />
            <h4>Historique Évènement :</h4>

            {selectedClient.historiques
              ?.filter(
                (hist) =>
                  hist.titre === "création d'évènement" &&
                  hist.eventId !== null &&
                  hist.evenement &&
                  hist.evenement.type === "Social" &&
                  hist.evenement.typeDate
              )
              .filter((hist) => {
                const eventDate = new Date(hist.evenement.typeDate);
                const eventMonth = eventDate.getMonth() + 1;
                const eventYear = eventDate.getFullYear();

                return (
                  eventMonth === Number(mois) && eventYear === Number(annee)
                );
              })
              .map((hist) => (
                <div key={hist.id} style={{ marginBottom: "10px" }}>
                  {/* Ligne visible en premier */}
                  <p>
                    {new Date(hist.evenement.typeDate).toLocaleDateString(
                      "fr-FR"
                    )}{" "}
                    – {hist.evenement.note || "Sans note"} –{" "}
                    <span
                      style={{
                        color: "#1E90FF",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setOpenedEventId(
                          openedEventId === hist.id ? null : hist.id
                        )
                      }
                    >
                      Consulter
                    </span>
                  </p>

                  {/* Détails affichés seulement si ouvert */}
                  {openedEventId === hist.id && (
                    <div
                      style={{
                        marginTop: "8px",
                        padding: "10px",
                        background: "#f0f8ff",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                      }}
                    >
                      {renderField("Note", hist.evenement.note)}
                      {renderField("Descriptif", hist.evenement.descriptif)}
                      {renderField("Catégorie", hist.evenement.categorie)}
                      {renderField("Téléphone", hist.evenement.tel || "")}
                      {renderField("Email", hist.evenement.email || "")}
                      {renderField("SMS", hist.evenement.sms || "")}
                      {renderField(
                        "Date d'échéance",
                        formatDate(hist.evenement.dateEcheance)
                      )}

                      {hist.evenement.bilanDocument && (
                        <p>
                          Bilan Document :{" "}
                          <a
                            href={hist.evenement.bilanDocument}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Voir document
                          </a>
                        </p>
                      )}
                    </div>
                  )}
                </div>
              ))}

            {/* Si aucun évènement Social correspondant */}
            {selectedClient.historiques &&
              selectedClient.historiques.filter(
                (h) =>
                  h.titre === "création d'évènement" &&
                  h.eventId !== null &&
                  h.evenement?.type === "Social"
              ).length === 0 && <p>Aucun évènement Social pour ce mois.</p>}
            <br />

            <hr style={{ margin: "5px 0", width: "100%" }} />
            <br />
            {tables.map((tableName) => {
              const tableData = data[tableName] || [];
              // Si aucune donnée, on ne retourne rien
              if (tableData.length === 0) return null;

              return (
                <div
                  key={tableName}
                  style={{
                    marginBottom: "25px",
                    border: "solid 0.5px grey",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    width: "95%",
                  }}
                >
                  <h4>{tableLabels[tableName] || tableName}</h4>

                  {tableData.map((item) => (
                    <div
                      key={item.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#eee",
                        padding: "10px",
                        borderRadius: "6px",
                        marginBottom: "8px",
                      }}
                    >
                      <span>
                        {item.commentaire}
                        {item.userName && (
                          <span
                            style={{
                              fontSize: "0.75em",
                              color: "#555",
                              marginLeft: "10px",
                            }}
                          >
                            - {item.userName}
                          </span>
                        )}
                      </span>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
